import { yearsToDays } from 'date-fns';
import React, { useEffect,  useState } from 'react';
import ApexCharts from 'react-apexcharts';

const ApexStackColumnChart = ({ xAxisList, dataList, type, width, colorList, isPNL }) => {
    const series = dataList;

    const [options, setOptions] = useState({
        chart: {
            type: 'bar',
            //height: 350,
            stacked: true,
            //stackType:'100%',
            toolbar: {
                show: true
            },
            zoom: {
                enabled: true
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 5,
                borderRadiusApplication: 'end', // 'around', 'end'
                borderRadiusWhenStacked: 'last', // 'all', 'last'
                dataLabels: {
                    enabled:true,
                    formatter: function (val) {
                        return val
                    },
                    style: {
                        fontSize: '1rem',
                        colors: ['#181717'],
                    },
                    total: {
                        enabled: true,
                        formatter: function (val, opt,) {
                            if (isPNL) {
                                const newData = (opt.w.globals.initialSeries[0]?.data) ?? "notdefine"
                                if (newData != "notdefine")
                                    return "₹." + newData[opt.dataPointIndex]?.amt
                            }
                        },

                        style: {
                            fontSize: '0.7rem',
                            fontWeight: 500,
                            colors: ['#181717']
                        }
                    }
                }
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    // width: "100%",
                    height: "500px"
                },
                legend: {
                    floating: false,
                    position: 'bottom',
                },
            },
        }],

        tooltip: isPNL ? {
            shared: false,
            intersect: false,
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                // Get the values of all series for this particular data point
                const newData = (w.globals.initialSeries[0]?.data) ?? "notdefine"
                const seriesData = series.map((data, index) => data[dataPointIndex]);
                let amt = 0
                if (newData != "notdefine")
                    amt = newData[dataPointIndex]?.amt ?? 0;
                // Create a custom tooltip content
                return `
                <div style="border-radius: 5px; border: 0px solid #ccc; font-size:0.8rem ">
                  <div style="background:#e5e7eb;padding:0.5rem;text-align:center;border-bottom:1px solid #cccccc">${w.globals.labels[dataPointIndex]}</div>
                  <div style="padding:0.7rem 2rem;">
                  <div style="font-size:0.8rem;align:top" >${amt < 0 ? "<span style='color:#f43f5e;font:bold;font-size:1rem '>&#8226;</span> Loss/MTR" : "<span style='color:#2fa133;font:bold;font-size:1rem '>&#8226;</span>Profit/Mtr"}: <strong> ${seriesData}</strong></div>
                  <div style="font-size:0.7rem;text-align:center"><strong> ${"₹." + amt}</strong></div>
                  </div>
                </div>
              `;

            },
        } : {},
        xaxis: {
            categories: xAxisList
        },
        yaxis: {
            min: 0
        },
        fill: {
            opacity: 1
        },
        legend: {
            position: 'bottom',
        },
        colors: isPNL ? [] : ['#eab308', '#06b6d4', '#f43f5e', '#10b981', '#a855f7', '#84cc16', '#3B82F6' ,'#f97316','#00bf3c'],
        //['#008ffb', '#00e396', '#775dd0', '#feb019', '#ff4560', '#ff5e00', '#9f3c77'],
    })


    useEffect(() => {
        // Update options whenever labels change
        setOptions(prevOptions => ({
            ...prevOptions,
            xaxis: { categories: xAxisList, },

        }));
    }, [series, xAxisList, dataList]);



    return (
        <div style={{}}>
            <ApexCharts
                // key={newkey}
                options={options}
                series={series}
                // tempd={}
                type={type}
                width={width ? width : "100%"}
            />

        </div>
    );
};

export default ApexStackColumnChart;
